import { Menu } from "@/design-system/Menu/Menu";
import { useTranslation } from "@repo/shared/i18n";
import { Check, EyeOff, Star } from "lucide-react";

export type SetToggleType = "favorite" | "hidden" | "completed";

type Props = {
  isFavorite: boolean;
  isHidden: boolean;
  isCompleted: boolean;
  /** Repeatable sets have nothing to complete. */
  disableComplete?: boolean;
  onMarkAsFavorite: () => void;
  onHide: () => void;
  onComplete: () => void;
};

/**
 * The three things you do to a set, rather than with it. What is SBC-specific
 * lives here: which actions there are, what they are called, and that an
 * unlimited set cannot be completed. The menu itself is the design system's.
 */
export const SetActionsMenu = ({
  isFavorite,
  isHidden,
  isCompleted,
  disableComplete,
  onMarkAsFavorite,
  onHide,
  onComplete,
}: Props) => {
  const { t } = useTranslation(["sbcs", "common"]);

  return (
    <Menu
      label={t("sbcs:setCard.moreActions")}
      items={[
        {
          value: "favorite",
          label: t("sbcs:toggle.favorite"),
          icon: <Star className="size-4" />,
          selected: isFavorite,
          onSelect: onMarkAsFavorite,
        },
        {
          value: "hidden",
          label: t("common:hide"),
          icon: <EyeOff className="size-4" />,
          selected: isHidden,
          onSelect: onHide,
        },
        {
          value: "completed",
          label: t("sbcs:toggle.complete"),
          icon: <Check className="size-4" />,
          selected: isCompleted,
          disabled: disableComplete,
          title: disableComplete
            ? t("sbcs:toggle.repeatableCantComplete")
            : undefined,
          onSelect: onComplete,
        },
      ]}
    />
  );
};
